import socket from '@/plugins/socket'
import * as API from '@/utils/constants/api-endpoints'

export const getInventory = () => socket.request(API.USER_INVENTORY)
export const getSteamInventory = type => socket.request(API.USER_STEAM_INVENTORY, type)
export const sellItems = ids => socket.request(API.SELL_ITEMS, ids)
export const swapItems = data => socket.request(API.USER_INVENTORY_SWAP, data)
export const checkItemStock = ids => socket.request(API.USER_INVENTORY_CHECK_STOCK, ids)
export const withdrawItems = ids => socket.request(API.USER_WITHDRAW, ids)

export const get = () => socket.request(API.USER_GET)
export const getWithdrawable = () => socket.request(API.USER_GET_WITHDRAWABLE)
export const claimGiftcode = data => socket.request(API.GIFTCODE_CLAIM, data)
export const redeemGiftCard = data => socket.request(API.GIFTCARD_CLAIM, data)
export const claimFaucet = token => socket.request(API.USER_CLAIM_FAUCET, token)
export const setTradeUrl = tradeUrl => socket.request(API.USER_SET_TRADEURL, tradeUrl)
export const setName = name => socket.request(API.USER_SET_NAME, name)
export const setEmail = email => socket.request(API.USER_SET_EMAIL, email)
export const getDepositAddress = coin => socket.request(API.CRYPTO_DEPOSIT_ADDRESS, coin)
export const deposit = assetids => socket.request(API.USER_DEPOSIT, assetids)
export const getPendingTrades = data => socket.request(API.USER_PENDING_TRADES, data)
export const getActiveSeedPair = () => socket.request(API.USER_GET_ACTIVE_SEED_PAIR)
export const createSeedPair = clientSecret => socket.request(API.USER_CREATE_SEED_PAIR, clientSecret)
export const redeemReferralCode = code => socket.request(API.USER_REDEEM_REFCODE, code)

export const getUserRewards = () => socket.request(API.USER_REWARDS_GET)
export const claimUserReward = id => socket.request(API.USER_REWARDS_CLAIM, id)
export const claimLevelRewards = () => socket.request(API.LEVEL_REWARDS_CLAIM)
export const getLevelCaseCooldown = () => socket.request(API.LEVEL_CASE_COOLDOWN)
export const getLevelCase = tier => socket.request(API.LEVEL_CASE_GET, tier)
export const openLevelCase = tier => socket.request(API.LEVEL_CASE_OPEN, tier)

export const getConnections = () => socket.request(API.USER_CONNECTIONS)
